<template>
  <div class="text-center w-full h-screen mt-0 bg-black">
    <br />
    <div class="mt-40">
      <h2 class="text-4xl text-primary mt-0 font-bluunext">
        Halaman Tidak Ditemukan!
      </h2>
      <p class="font-nunito text-gray-400 text-xs mt-10">
        Err request: 404 not found
      </p>
    </div>
  </div>
</template>
